import React, { Component } from 'react';
import { number, string } from 'prop-types';
import styles from './Counter.scss';
import CSSTransition from 'react-transition-group/CSSTransition';
import TransitionGroup from 'react-transition-group/TransitionGroup';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = { direction: null, value: null, height: null };
    this.myRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    return {
      value: props.value,
      direction: state.value > props.value ? 'down' : 'up',
    };
  }

  componentDidMount() {
    this.setState({
      height: this.myRef.current.clientHeight,
    });
  }

  render() {
    const className = this.state.direction === 'up' ? styles.numberContainerUp : styles.numberContainerDown;
    const style = { height: this.state.height };

    const cssTransitionClassNames = {
      enter: styles.numberEnter,
      enterActive: styles.numberEnterActive,
      exit: styles.numberExit,
      exitActive: styles.numberExitActive,
    };

    return (
      <TransitionGroup className={`${className} ${this.props.className}`} style={style}>
        <CSSTransition
          key={this.props.value}
          timeout={200}
          className={styles.number}
          classNames={cssTransitionClassNames}
        >
          <div ref={this.myRef} data-hook="cart-item-quantity-value">{this.props.value}</div>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}

Counter.propTypes = {
  value: number,
  className: string,
};

Counter.defaultProps = {
  value: 0,
};

export default Counter;
